/* eslint-disable no-unused-expressions */
import decorators from './decorators'

const setDecorator = (name, version) => decorators[name]?.setDecorator(version)

export default setDecorator
